import React from "react";

const FACTS = [
  {
    title: "Global Curation",
    detail: "Sourced for South Florida.",
  },
  {
    title: "Tailored Design",
    detail: "Expert advice for your vision.",
  },
  {
    title: "Dedicated Support",
    detail: "Partnering through every phase.",
  },
  {
    title: "Premium Quality",
    detail: "Carefully vetted materials.",
  },
];

export const About = () => {
  return (
    <section id="about" className="section bg-[#FFFFFF] border-y border-[#E5E0D8]">
      <div className="container-wide grid md:grid-cols-12 gap-12 md:gap-20 items-start">
        <div className="md:col-span-5 md:sticky md:top-28">
          <span className="label-overline">Why In Stone</span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1] font-light">
            Built around the
            <br />
            <span className="italic text-[#8C7A6B]">South Florida craft.</span>
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <p className="text-[#5C5C5C] text-base sm:text-lg leading-relaxed">
            We combine a globally curated selection of premium stone and tile with
            expert design advice and hands-on project support. Our team delivers an
            unparalleled level of personalized customer service to ensure your space
            perfectly reflects your architectural vision.
          </p>
          <div className="mt-12 grid sm:grid-cols-2 gap-10 md:gap-12 border-t border-[#E5E0D8] pt-10">
            {FACTS.map((f) => (
              <div key={f.title}>
                <p className="font-heading text-2xl sm:text-3xl text-[#1A1A1A] font-normal leading-tight">
                  {f.title}
                </p>
                <p className="mt-3 text-[#5C5C5C] leading-relaxed">{f.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
